module.exports = __webpack_public_path__ + "img/imgSLOGAN.004018e5.png";